import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const HERO = "https://images.unsplash.com/photo-1769971436303-698fccb35111?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxzdHJlZXR3ZWFyJTIwZmFzaGlvbiUyMGRhcmslMjBwaG90b2dyYXBoeXxlbnwwfHx8fDE3ODgyNDI0MTB8MA&ixlib=rb-4.1.0&q=85";

export default function Home() {
  const [featured, setFeatured] = useState([]);
  const [latest, setLatest] = useState([]);
  const [soon, setSoon] = useState([]);
  const [cats, setCats] = useState([]);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    api.get("/products", { params: { featured: true, limit: 4 } }).then((r) => setFeatured(r.data));
    api.get("/products", { params: { new_drop: true, limit: 8 } }).then((r) => setLatest(r.data));
    api.get("/products", { params: { coming_soon: true, limit: 4 } }).then((r) => setSoon(r.data));
    api.get("/categories").then((r) => setCats(r.data));
    api.get("/settings").then((r) => setSettings(r.data || {}));
  }, []);

  return (
    <div>
      {/* Hero */}
      <section className="relative h-[80vh] md:h-[92vh] w-full overflow-hidden">
        <img src={HERO} alt="hero" className="absolute inset-0 w-full h-full object-cover opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
        <div className="relative z-10 h-full flex flex-col justify-end px-4 sm:px-8 pb-16 max-w-[1600px] mx-auto">
          <div className="text-[10px] tracking-widest text-neutral-400 mb-4">SS/26 · {(settings.tagline || "STREETWEAR FOR THE VOICELESS")}</div>
          <h1 data-testid="hero-heading" className="display text-6xl md:text-[10rem] leading-none">{settings.brand_name || "FERAL RIOT"}.<br/>MADE TO ORDER.</h1>
          <p className="text-neutral-300 max-w-md mt-6 text-sm">Setiap desain kami cetak dengan teknik DTF setelah pesanan masuk. Nol stok mati, nol limbah tekstil.</p>
          <div className="mt-8 flex gap-3">
            <Link to="/shop" data-testid="hero-shop-btn" className="inline-block bg-white text-black px-8 py-4 text-xs tracking-widest hover:bg-[color:var(--accent)] hover:text-white transition-colors">BELANJA SEKARANG</Link>
            <Link to="/shop?new=1" data-testid="hero-latest-btn" className="inline-block border border-white text-white px-8 py-4 text-xs tracking-widest hover:bg-white hover:text-black transition-colors">LATEST DROPS</Link>
          </div>
        </div>
      </section>

      {/* Featured */}
      {featured.length > 0 && (
        <section className="max-w-[1600px] mx-auto px-4 sm:px-8 py-16">
          <div className="flex items-end justify-between mb-8">
            <h2 className="display text-4xl md:text-6xl">FEATURED</h2>
            <Link to="/shop" className="text-xs tracking-widest hover:text-[color:var(--accent)]">LIHAT SEMUA →</Link>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-8">
            {featured.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        </section>
      )}

      {/* Categories band */}
      <section className="border-y border-[color:var(--border)] py-16">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-8">
          <h2 className="display text-4xl md:text-6xl mb-8">KATEGORI</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {cats.map((c) => (
              <Link key={c.id} to={`/shop?category=${c.slug}`} data-testid={`cat-${c.slug}`} className="border border-[color:var(--border)] p-8 hover:bg-white hover:text-black transition-colors flex flex-col justify-between h-40">
                <span className="text-[10px] tracking-widest text-neutral-500 group-hover:text-black">CATEGORY</span>
                <span className="display text-3xl">{c.name}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Latest Drops */}
      {latest.length > 0 && (
        <section className="max-w-[1600px] mx-auto px-4 sm:px-8 py-16">
          <div className="flex items-end justify-between mb-8">
            <h2 className="display text-4xl md:text-6xl">LATEST DROPS</h2>
            <Link to="/shop?new=1" className="text-xs tracking-widest hover:text-[color:var(--accent)]">SEMUA DROPS →</Link>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-8">
            {latest.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        </section>
      )}

      {/* Coming Soon */}
      {soon.length > 0 && (
        <section className="bg-[color:var(--surface)] py-16">
          <div className="max-w-[1600px] mx-auto px-4 sm:px-8">
            <h2 className="display text-4xl md:text-6xl mb-8">COMING SOON</h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-8">
              {soon.map((p) => <ProductCard key={p.id} product={p} />)}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
